import { useAppNavigate } from "../../../../hooks/useAppNavigate";
import React from "react";
import { useProgramme } from "../../contexts/programme.context";
import { WizardHeading } from "../../../../core/components/WizardHeading";
import ManageProgrammeFacilitators from "./ManageProgrammeFacilitators";
import { useAuth } from "../../../../contexts/auth.context";
import { getRoleDisplayNamePlural } from "../../../users/entities/RoleType";

export const ProgrammeFacilitators: React.FC = (): JSX.Element => {
    const { submitStep, programme } = useProgramme();
    const { push } = useAppNavigate();
    const { user } = useAuth();
    const facilitatorLabelPlural = getRoleDisplayNamePlural("Facilitator", user?.isSchool);
    const onSubmit = () => {
        if (programme) {
            submitStep(programme);
            push(`/programmes/view/${programme.id}`);
        }
    };
    return (
        <>
            {programme && (
                <>
                    <WizardHeading overline={"Schedule a programme"} heading={`Assign ${facilitatorLabelPlural}`} />
                    <ManageProgrammeFacilitators programme={programme} onSubmit={onSubmit} programmeCreate={true} />
                </>
            )}
        </>
    );
};
